import { Footerstrip as Strip } from '../../components/Ads'
import { FooterStripWrap } from './FooterStrip.style'

export const FooterStrip = () => {
  const onRender = () => null
  return (
    <FooterStripWrap>
      <Strip onAdRender={onRender} />
    </FooterStripWrap>
  )
}
